import { render, staticRenderFns } from "./lotteryStage.vue?vue&type=template&id=783dc8a4&scoped=true"
import script from "./lotteryStage.vue?vue&type=script&lang=js"
export * from "./lotteryStage.vue?vue&type=script&lang=js"
import style0 from "./lotteryStage.vue?vue&type=style&index=0&id=783dc8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783dc8a4",
  null
  
)

export default component.exports